<template>
  <div class="navigator-section" v-show="active">
      <div v-for="index in 6" :key="index" class="navigator-item">
        <img :src="active !== index ? images['navigator0' + index] : images['navigatorActive0' + index]" @click="$emit('update:active', index)"/>
      </div>
  </div>
</template>

<script>
import images from '@/utils/images.js'
export default {
    props: {
        active: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            images: images
        }
    }
}
</script>

<style lang="scss" scoped>
.navigator-section {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    box-sizing: border-box;
    padding: 15px;
    background: #0c426a;
    z-index: 20;
    display: flex;
    .navigator-item {
        flex: 1;

        img {
            width: 100%;
        }
    }
}
</style>